import { Component, Input, OnInit } from '@angular/core';
import { ErrorWrapper } from '../@shared/models/response-wrapper.model';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ApplicationRouterService } from '../@core/application-router/application-router.service';
import { MarcheAPIService } from '../@core/api/marche-api.service';
import { RouteExecutor } from '../@core/application-router/route.executor';
import { OfferToggleService } from './offer-toggle.service';

@Component({
    selector: 'app-offer-toggle',
    templateUrl: './offer-toggle.component.html',
    styleUrls: ['./offer-toggle.component.scss'],
})
export class OfferToggleComponent extends RouteExecutor implements OnInit {
    @Input() filters: { [p: string]: string | string[] } = {};
    @Input() page = '';

    errors: ErrorWrapper[] | undefined = [];
    pagedata: any;
    loading = true;

    constructor(
        private marcheAPIService: MarcheAPIService,
        applicationRouterService: ApplicationRouterService,
        public dialog: MatDialog,
        private activatedRoute: ActivatedRoute,
        private OfferToggleService: OfferToggleService
    ) {
        super(applicationRouterService);
    }

    ngOnInit(): void {
        this.OfferToggleService.OfferToggle({ page: this.page }).subscribe(
            res1 => {
                this.loading = false;
                if (res1?.success) {
                    this.pagedata = res1?.data;
                } else {
                    this.pagedata = null;
                }
            }
        );
    }
}
